import { InjectionToken } from '@angular/core';

export const ALERT_DATA = new InjectionToken<any>('ALERT_DATA');